export default [
    "Afrique du Sud",
    "Algérie",
    "Allemagne",
    "Arabie Saoudite",
    "Argentine",
    "Arménie",
    "Athlètes Individuels Neutres",
    "Australie",
    "Autriche",
    "Azerbaïdjan",
    "Bahreïn",
    "Belgique",
    "Bolivie",
    "Bosnie-Herzégovine",
    "Brésil",
    "Bulgarie",
    "Burkina Faso",
    "Cameroun",
    "Canada",
    "Chine",
    "Corée du Sud",
    "Costa Rica",
    "Croatie",
    "Cuba",
    "Danemark",
    "Djibouti",
    "Égypte",
    "Émirats Arabes Unis",
    "Équateur",
    "Équipe Olympique des Réfugiés",
    "Érythrée",
    "Espagne",
    "Estonie",
    "États-Unis",
    "Éthiopie",
    "Fidji",
    "Finlande",
    "France",
    "Gambie",
    "Géorgie",
    "Grande-Bretagne",
    "Grèce",
    "Guatemala",
    "Guinée-Bissau",
    "Hong Kong",
    "Hongrie",
    "Inde",
    "Iran",
    "Irlande",
    "Israël",
    "Italie",
    "Jamaïque",
    "Japon",
    "Kazakhstan",
    "Kenya",
    "Kosovo",
    "Liban",
    "Lituanie",
    "Maroc",
    "Mexique",
    "Moldavie",
    "Nigeria",
    "Norvège",
    "Nouvelle-Zélande",
    "Ouganda",
    "Pakistan",
    "Pays-Bas",
    "Pérou",
    "Philippines",
    "Pologne",
    "Porto Rico",
    "Portugal",
    "Qatar",
    "République Dominicaine",
    "Roumanie",
    "Samoa",
    "Sénégal",
    "Serbie",
    "Singapour",
    "Slovaquie",
    "Slovénie",
    "Suède",
    "Suisse",
    "Suriname",
    "Taipei Chinois",
    "Tanzanie",
    "Tchéquie",
    "Trinité-et-Tobago",
    "Tunisie",
    "Turquie",
    "Ukraine",
    "Uruguay",
    "Viêt Nam",
    "Zimbabwe",
  ];